import { getGuid } from 'owa-guid';
import { lazyLogSearchEntityActions } from 'owa-search-instrumentation';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { ReplyWithAttachmentSuggestion } from '../store/schema/AttachmentSuggestions';

export default function logAttachmentSuggestionClicked(suggestion: ReplyWithAttachmentSuggestion) {
    const sessionSettings = getUserConfiguration().SessionSettings;
    lazyLogSearchEntityActions.importAndExecute(
        SubstrateSearchScenario.SuggestedAttachments,
        sessionSettings.UserPuid,
        sessionSettings.ExternalDirectoryTenantGuid,
        getGuid(),
        suggestion.TraceId,
        suggestion.ReferenceId,
        'EntityClicked',
        null /* metadata */,
        suggestion.TraceId
    );
}
